import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { RefreshCw } from "lucide-react";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("pt-BR") : "—");
const KIND = {
  action: { label: "Ação", cls: "chip-success" },
  view: { label: "Consulta", cls: "chip-judge" },
  denied: { label: "Negado", cls: "chip-admin" },
  auth: { label: "Login", cls: "chip-judge" },
  admin: { label: "Admin", cls: "chip-admin" },
};

export const ActivityLog = ({ operators, competitions }) => {
  const [items, setItems] = useState([]);
  const [userId, setUserId] = useState("");
  const [compId, setCompId] = useState("");
  const [onlyActions, setOnlyActions] = useState(true);
  const [busy, setBusy] = useState(false);

  const load = async () => {
    setBusy(true);
    try {
      const params = { limit: 300 };
      if (userId) params.user_id = userId;
      if (compId) params.competition_id = compId;
      if (onlyActions) params.kind = "actions";
      const { data } = await api.get("/admin/activity-logs", { params });
      setItems(data);
    } finally {
      setBusy(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line
  }, [userId, compId, onlyActions]);

  return (
    <div data-testid="activity-log">
      <div className="card p-4 mb-4 grid grid-cols-1 md:grid-cols-[1fr_1fr_auto_auto] gap-3 items-end">
        <div>
          <label className="overline block mb-1">Operadora</label>
          <select data-testid="log-filter-user" className="input-field" value={userId} onChange={(e) => setUserId(e.target.value)}>
            <option value="">Todas</option>
            {operators.map((o) => <option key={o.id} value={o.id}>{o.name}</option>)}
          </select>
        </div>
        <div>
          <label className="overline block mb-1">Campeonato</label>
          <select data-testid="log-filter-comp" className="input-field" value={compId} onChange={(e) => setCompId(e.target.value)}>
            <option value="">Todos</option>
            {competitions.map((c) => <option key={c.id} value={c.id}>{c.nome}</option>)}
          </select>
        </div>
        <label className="flex items-center gap-2 text-xs cursor-pointer pb-2.5">
          <input data-testid="log-filter-actions" type="checkbox" className="accent-[#C9A84C]" checked={onlyActions} onChange={(e) => setOnlyActions(e.target.checked)} />
          Só ações (ocultar consultas)
        </label>
        <button data-testid="log-refresh" className="btn-ghost inline-flex items-center gap-2" onClick={load} disabled={busy}>
          <RefreshCw size={14} className={busy ? "animate-spin" : ""} /> Atualizar
        </button>
      </div>

      <div className="card overflow-x-auto">
        <table className="table-dense">
          <thead>
            <tr>
              <th className="w-40">Data / Hora</th>
              <th>Usuária</th>
              <th>Ação</th>
              <th>Campeonato</th>
              <th>Detalhe</th>
              <th className="w-24">Tipo</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && (
              <tr><td colSpan={6} className="text-center py-8 text-[var(--text-secondary)]">{busy ? "Carregando..." : "Nenhuma atividade registrada."}</td></tr>
            )}
            {items.map((l) => {
              const k = KIND[l.kind] || KIND.action;
              return (
                <tr key={l.id} data-testid={`log-row-${l.id}`} className={l.kind === "denied" ? "bg-[#C9A84C]/5" : ""}>
                  <td className="text-xs tabular-nums whitespace-nowrap">{fmt(l.created_at)}</td>
                  <td>
                    <div className="text-sm">{l.user_name}</div>
                    <div className="text-[10px] text-[var(--text-secondary)]">{l.user_email}</div>
                  </td>
                  <td className="text-sm font-semibold">{l.action}</td>
                  <td className="text-xs">{l.competition_name || "—"}</td>
                  <td className="text-xs text-[var(--text-secondary)] max-w-[320px] truncate" title={l.details || l.path}>
                    {l.details || l.path}
                  </td>
                  <td><span className={`chip ${k.cls}`}>{k.label}</span></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="text-[11px] text-[var(--text-secondary)] mt-2">
        Mostrando até 300 registros mais recentes. Horários no fuso do seu navegador.
      </div>
    </div>
  );
};
